import { TraitRegistryCategory } from '../TraitRegistryCategory';
export class TraitRegistryMediaHear extends TraitRegistryCategory {
    label = 'Hear';
    constructor(parent) {
        super(parent);
        super.init();
    }
}
